import { render, staticRenderFns } from "./SmartVenueContent.vue?vue&type=template&id=b54caf66&scoped=true&"
import script from "./SmartVenueContent.vue?vue&type=script&lang=js&"
export * from "./SmartVenueContent.vue?vue&type=script&lang=js&"
import style0 from "./SmartVenueContent.vue?vue&type=style&index=0&id=b54caf66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54caf66",
  null
  
)

export default component.exports